<template>
  <div class="box">
    <div class="columns">
      <div class="column is-two-thirds">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">Project Name</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder=""
                  v-model="filterParams.projectName"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Administrator</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder=""
                  v-model="filterParams.administrator"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-half">
            <b-field label="Administrator Status">
              <b-dropdown
                v-model="filterParams.administratorStatus"
                aria-role="list"
                class="simple-dropdown"
              >
                <button
                  class="button is-primary role-select-button"
                  slot="trigger"
                >
                  <span class="text-input">
                    {{
                      filterParams.administratorStatus ===
                      administratorStatusOptions.all
                        ? 'All Status'
                        : filterParams.administratorStatus ===
                          administratorStatusOptions.active
                        ? 'Active'
                        : 'Expired'
                    }}
                  </span>
                  <b-icon
                    type="is-black"
                    icon="menu-down"
                    size="is-small"
                  ></b-icon>
                </button>

                <b-dropdown-item
                  :value="value"
                  v-for="value in administratorStatusOptions"
                  :key="value"
                  aria-role="listitem"
                  class="simple-dropdown-item"
                >
                  {{
                    value === administratorStatusOptions.all
                      ? 'All Status'
                      : value === administratorStatusOptions.active
                      ? 'Active'
                      : 'Expired'
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="columns">
          <div class="column">
            <b-field label="Project Status">
              <b-dropdown
                v-model="filterParams.projectStatus"
                aria-role="list"
                class="simple-dropdown"
              >
                <button
                  class="button is-primary role-select-button"
                  slot="trigger"
                >
                  <span class="text-input">
                    {{
                      filterParams.projectStatus === projectStatusOptions.all
                        ? 'All Status'
                        : filterParams.projectStatus ===
                          projectStatusOptions.active
                        ? 'Active'
                        : filterParams.projectStatus ===
                          projectStatusOptions.draft
                        ? 'Draft'
                        : 'Archived'
                    }}
                  </span>
                  <b-icon
                    type="is-black"
                    icon="menu-down"
                    size="is-small"
                  ></b-icon>
                </button>

                <b-dropdown-item
                  :value="value"
                  v-for="value in projectStatusOptions"
                  :key="value"
                  aria-role="listitem"
                  class="simple-dropdown-item"
                >
                  {{
                    value === projectStatusOptions.all
                      ? 'All Status'
                      : value === projectStatusOptions.active
                      ? 'Active'
                      : value === projectStatusOptions.draft
                      ? 'Draft'
                      : 'Archived'
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left" />
      <div class="level-right">
        <a @click="$emit('reset')" :class="[$style.clearFilter, `level-item`]">
          Clear Filter
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilteredUserPayload } from '@/store/modules/users/types/users.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';

@Component({
  components: {},
})
export default class ProjectFilter extends Vue {
  @Prop(Object) public filterParams!: any;
  public projectStatusOptions = {
    all: '',
    active: 'active',
    draft: 'draft',
    archived: 'archived',
  };
  public administratorStatusOptions = {
    all: '',
    active: 'active',
    expired: 'expired',
  };

  @Watch('filterParams', { deep: true })
  public onChange() {
    this.$emit('input', this.filterParams);
  }
}
</script>

<style lang="scss" module>
.clearFilter {
  color: #21b5ea;
  font-size: 14px;
  font-weight: bold;
}
.customSelectAdministratorStatus {
  select {
    background-color: transparent;
    border-color: #dbdbdb;
    border-radius: 4px;
    color: #363636;
    height: 2.5em;
    cursor: pointer;
    font-size: 16px;
    padding: 8px 320px 10px 8px;
  }
}
</style>
